import { CardContent as CardContentComponent } from './CardContent.component';
import { connector } from './CardContent.connector';

export const CardContent = connector(CardContentComponent);
